/*** IMPORTS FROM imports-loader ***/
var define = false;

// Importing fullpage.js
// import fullpage from 'fullpage.js';
// When using fullPage extensions replace the previous import
// of fullpage.js for this file
// require('src:vendors/fullpage.js/fullpage.parallax.min.js');
// require('src:vendors/fullpage.js/fullpage.scrollOverflowReset.min.js');
import parallax from 'src:vendors/fullpage.js/fullpage.parallax.min.js';
import scrolloverflowreset from 'src:vendors/fullpage.js/fullpage.scrollOverflowReset.min.js';
import scrolloverflow from 'fullpage.js/vendors/scrolloverflow.min';
import fullpage from 'fullpage.js/dist/fullpage.extensions.min';

(function ($, window, document, undefined) {
  $(document).ready(function () {
    // Prepare fullPage elements
    var target = '#main-content.main-content--is-front';
    $(target)
      .children().addClass('section')
      .find('.node__poster').addClass('fp-bg');
    // Add slide navigation to testimonials paragraphs
    $(target).find('.paragraph--testimonials').each(function () {
      var group = $(this),
        group_anchor = group.data('anchor'),
        quote = group.find('.paragraph--testimonial'),
        group_menu = $('<ul class="testimonials-menu">');
      quote.each(function (i) {
        var item = $(this),
          item_anchor = item.data('anchor'),
          item_tooltip = item.data('tooltip'),
          count = i + 1,
          button = $('<button data-slide="' + i + '" id="' + group_anchor + '-' + item_anchor + '" aria-label="Go to testimonial ' + count + '" class="testimonials-menu__button">' + count + '</button>'),
          item_list = $('<li class="testimonials-menu__item"></li>');
        button.on('click', function () {
          fullPageInstance.moveTo(group_anchor, i);
        });
        item.addClass('slide fp-auto-height');
        item_list.append(button)
        group_menu.append(item_list);
      });
      group.find('.paragraph__content').append(group_menu);
    });
    // Initialize the fullPage
    var fullPageInstance = new fullpage(target, {
      licenseKey: 'B1FCE685-71184ABB-ADAA9075-9F7E499E',
      controlArrows: false,
      easingcss3: 'ease-out',
      fixedElements: '.footer',
      loopHorizontal: false,
      navigation: true,
      parallax: true,
      parallaxOptions: {
        type: 'cover',
        percentage: 100,
        property: 'translate'
      },
      parallaxKey: 'c3F1YXJlMzYwLmNvbV82WVVjR0Z5WVd4c1lYZz0wcFU=',
      scrollOverflowResetKey: 'c3F1YXJlMzYwLmNvbV81NTNjMk55YjJ4c1QzWmxjbVpzYjNkU1pYTmxkQT09cHpB',
      scrollOverflowReset: true,
      scrollOverflow: true,
      // slidesNavigation: true,
      // licenseKey: '([\\d\\w]{8}-){3}[\\d\\w]{8}|^(?=.*?[A-Y])(?=.*?[a-y])(?=.*?[0-8])(?=.*?[#?!@$%^&*-]).{8,}$',

      onLeave: function (origin, destination, direction) {
        var leavingSection = this,
          destinationClasses = destination.item.className;
        // change the data-black-background based on slide context
        if (~destinationClasses.indexOf("paragraph--white-background") || ~destinationClasses.indexOf("paragraph--yellow-background")) {
          $('body').attr('data-black-background', 'false');
        } else {
          $('body').attr('data-black-background', 'true');
        }
        // show the destination images
        $(destination.item).find('img').addClass('js--media-in');
        // hide the origin images
        $(origin.item).find('img').removeClass('js--media-in');
      },
      afterLoad: function (origin, destination, direction) {
        //
      },
      afterSlideLoad: function (section, origin, destination, direction) {
        $('.paragraph--testimonials[data-anchor=' + section.anchor + '] button').removeClass('active');
        $('.paragraph--testimonials[data-anchor=' + section.anchor + '] button[data-slide=' + destination.index + ']').addClass('active');
      }
    });
  });
})(jQuery, window, document);
